fun getCountryFlagEmoji(countryCode: String): String =
    countryCode.map { "${0xD83C.toChar()}${(0xDDA5 + it.code).toChar()}" }.joinToString("")

fun getCountryName(countryCode: String): String {
    val names = js("new Intl.DisplayNames(['en'], { type: 'region' })")
    return if (countryCode.length > 2) {
        val subdivisionName = subdivisionNames[countryCode] ?: countryCode.substring(3)
        names.of(countryCode.substring(0,2)) + ": " + subdivisionName
    } else {
        names.of(countryCode)
    }
}

private val subdivisionNames = mapOf(
    "AU-ACT" to "Australian Capital Territory",
    "AU-NSW" to "New South Wales",
    "AU-NT" to  "Northern Territory",
    "AU-QLD" to "Queensland",
    "AU-SA" to  "South Australia",
    "AU-TAS" to "Tasmania",
    "AU-VIC" to "Victoria",
    "AU-WA" to  "Western Australia",

    "BE-BRU" to "Brussels-Capital Region",
    "BE-VLG" to "Flemish Region",
    "BE-WAL" to "Walloon Region",

    "NL-BQ1" to "Bonaire",
    "NL-BQ2" to "Saba",
    "NL-BQ3" to "Sint Eustatius",
    
    "CA-AB" to "Alberta",
    "CA-BC" to "British Columbia",
    "CA-MB" to "Manitoba",
    "CA-NB" to "New Brunswick",
    "CA-NL" to "Newfoundland and Labrador",
    "CA-NS" to "Nova Scotia",
    "CA-NT" to "Northwest Territories",
    "CA-NU" to "Nunavut",
    "CA-ON" to "Ontario",
    "CA-PE" to "Prince Edward Island",
    "CA-QC" to "Quebec",
    "CA-SK" to "Saskatchewan",
    "CA-YT" to "Yukon Territory",

    "CN-AH" to "Anhui",
    "CN-BJ" to "Beijing",
    "CN-CQ" to "Chongqing",
    "CN-FJ" to "Fujian",
    "CN-GS" to "Gansu",
    "CN-GD" to "Guangdong",
    "CN-GX" to "Guangxi",
    "CN-GZ" to "Guizhou",
    "CN-HA" to "Henan",
    "CN-HB" to "Hubei",
    "CN-HE" to "Hebei",
    "CN-HI" to "Hainan",
    "CN-HK" to "Hong Kong",
    "CN-HL" to "Heilongjiang",
    "CN-HN" to "Hunan",
    "CN-JL" to "Jilin",
    "CN-JS" to "Jiangsu",
    "CN-JX" to "Jiangxi",
    "CN-LN" to "Liaoning",
    "CN-NM" to "Nei Monggol",
    "CN-NX" to "Ningxia",
    "CN-QH" to "Qinghai",
    "CN-SC" to "Sichuan",
    "CN-SD" to "Shandong",
    "CN-SH" to "Shanghai",
    "CN-SN" to "Shaanxi",
    "CN-SX" to "Shanxi",
    "CN-TJ" to "Tianjin",
    "CN-TW" to "Taiwan",
    "CN-XJ" to "Xinjiang",
    "CN-XZ" to "Xizang",
    "CN-YN" to "Yunnan",
    "CN-ZJ" to "Zhejiang",

    "FM-KSA" to "Kosrae",
    "FM-PNI" to "Pohnpei",
    "FM-TRK" to "Chuuk",
    "FM-YAP" to "Yap",

    "GB-SCT" to "Scotland",

    "IN-AN" to "Andaman and Nicobar Islands",
    "IN-AP" to "Andhra Pradesh",
    "IN-AR" to "Arunachal Pradesh",
    "IN-AS" to "Assam",
    "IN-BR" to "Bihar",
    "IN-CH" to "Chandigarh",
    "IN-DD" to "Daman and Diu",
    "IN-DL" to "Delhi",
    "IN-DN" to "Dadra and Nagar Haveli",
    "IN-GA" to "Goa",
    "IN-GJ" to "Gujarat",
    "IN-HR" to "Haryana",
    "IN-HP" to "Himachal Pradesh",
    "IN-JK" to "Jammu and Kashmir",
    "IN-KA" to "Karnataka",
    "IN-KL" to "Kerala",
    "IN-LD" to "Lakshadweep",
    "IN-MH" to "Maharashtra",
    "IN-ML" to "Meghalaya",
    "IN-MN" to "Manipur",
    "IN-MP" to "Madhya Pradesh",
    "IN-MZ" to "Mizoram",
    "IN-NL" to "Nagaland",
    "IN-OR" to "Orissa",
    "IN-PB" to "Punjab",
    "IN-PY" to "Pondicherry",
    "IN-RJ" to "Rajasthan",
    "IN-SK" to "Sikkim",
    "IN-TN" to "Tamil Nadu",
    "IN-TR" to "Tripura",
    "IN-UP" to "Uttar Pradesh",
    "IN-WB" to "West Bengal",

    "US-AL" to "Alabama",
    "US-AK" to "Alaska",
    "US-AR" to "Arkansas",
    "US-AS" to "American Samoa",
    "US-AZ" to "Arizona",
    "US-CA" to "California",
    "US-CO" to "Colorado",
    "US-CT" to "Connecticut",
    "US-DC" to "District of Columbia",
    "US-DE" to "Delaware",
    "US-FL" to "Florida",
    "US-GA" to "Georgia",
    "US-GU" to "Guam",
    "US-HI" to "Hawaii",
    "US-IA" to "Iowa",
    "US-ID" to "Idaho",
    "US-IL" to "Illinois",
    "US-IN" to "Indiana",
    "US-KS" to "Kansas",
    "US-KY" to "Kentucky",
    "US-LA" to "Louisiana",
    "US-MA" to "Massachusetts",
    "US-MD" to "Maryland",
    "US-ME" to "Maine",
    "US-MI" to "Michigan",
    "US-MN" to "Minnesota",
    "US-MO" to "Missouri",
    "US-MP" to "Northern Mariana Islands",
    "US-MS" to "Mississippi",
    "US-MT" to "Montana",
    "US-NC" to "North Carolina",
    "US-ND" to "North Dakota",
    "US-NE" to "Nebraska",
    "US-NH" to "New Hampshire",
    "US-NJ" to "New Jersey",
    "US-NM" to "New Mexico",
    "US-NV" to "Nevada",
    "US-NY" to "New York",
    "US-OH" to "Ohio",
    "US-OK" to "Oklahoma",
    "US-OR" to "Oregon",
    "US-PA" to "Pennsylvania",
    "US-PR" to "Puerto Rico",
    "US-RI" to "Rhode Island",
    "US-SC" to "South Carolina",
    "US-SD" to "South Dakota",
    "US-TN" to "Tennessee",
    "US-TX" to "Texas",
    "US-UM" to "United States Minor Outlying Islands",
    "US-UT" to "Utah",
    "US-VA" to "Virginia",
    "US-VI" to "Virgin Islands, U.S.",
    "US-VT" to "Vermont",
    "US-WA" to "Washington",
    "US-WI" to "Wisconsin",
    "US-WV" to "West Virginia",
    "US-WY" to "Wyoming",
)
